import { render } from "./MessageIn.vue?vue&type=template&id=3885d63e"
import script from "./MessageIn.vue?vue&type=script&lang=ts"
export * from "./MessageIn.vue?vue&type=script&lang=ts"
script.render = render

export default script